import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { environment } from '../../environments/environment';
import { initConfirmations, selectConfirmationCollectionLoaded } from '@evorait/pace-core';
import { of } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

export const ConfirmationIsLoadedGuard: CanActivateFn = () => {
    const store = inject(Store);

    if (!environment.enableNgRx) {
        return of(true);
    } else {
        return store.select(selectConfirmationCollectionLoaded).pipe(
            tap((confirmationCollectionLoaded) => {
                if (!confirmationCollectionLoaded) {
                    store.dispatch(initConfirmations());
                }
            }),
            filter((confirmationCollectionLoaded) => confirmationCollectionLoaded),
        );
    }
};
